import * as tracking from 'dibs-tracking';

const DEFAULT_FEATURED_TARCKING_OBJ = {
    id: 'L2-result-tiles',
    name: 'L1|Result Tiles',
};

export function trackPromoImpressions(promotions: string[], position?: number): void {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: promotions.map((promotion, index) => ({
            position: position || index + 1,
            creative: promotion,
            ...DEFAULT_FEATURED_TARCKING_OBJ,
        })),
    });
}

export const trackPromoClick = (promotion: string, position: number = 1): void => {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                position,
                creative: promotion,
                ...DEFAULT_FEATURED_TARCKING_OBJ,
            },
        ],
    });
};
